/**
 * Module definition houses all application routes
 *
 * @module routes
 */

angular.module('routes', [
  'routes.PayloadResolver',
  'routes.MainController',
  'routes.error',
  'routes.reports',
  'routes.simulation'
]).config(
  [
    '$stateProvider',
    function ($stateProvider) {
      'use strict';

      $stateProvider
        .state('routes', {
          url: null,
          templateUrl: 'routes/routes.html',
          resolve: {
            newmanPayload: ['PayloadResolver', function (PayloadResolver) {
              return new PayloadResolver();
            }]
          },
          controller: 'MainController'
        }
      );
    }
  ]
);
